import {getDeniveles, getElevationsForCoords, getMinimumAndMaximumsSimplified} from "../altitudes";
import { getSpeeds, getHoursOfWalk} from "./speedHelper";

// TODO: voir si 400 points c'est assez ?
// TODO : trajet de plus de 25 km , denivelee peut etre pas precis
const handleLongLat = ((coordLongLat) => [coordLongLat[1], coordLongLat[0]])

const pointToIgnString = ({lat, lng}) => `${lng},${lat}`

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const reportResult = (listOfPoints, result) => {
  const speeds = getSpeeds()
  const up = result.altitudeProfile.deniveles.up
  const down = result.altitudeProfile.deniveles.down
  const {pathCoordinates: _, ...global} = result;

  const stepsHours = result.portions.map(
    ({distance: portionDistance, deniveles: portionDeniveles}, index) => (
      getHoursOfWalk(speeds, portionDistance, portionDeniveles.up, portionDeniveles.down)
    )
  )

  const sent = {
    id: getCookie("_hjSessionUser_3037771"),
    search: window.location.search,
    points: listOfPoints,
    total_km: result.distance,
    total_hours: getHoursOfWalk(speeds, result.distance, up, down),
    total_up: result.altitudeProfile.deniveles.up,
    total_down: result.altitudeProfile.deniveles.down,
    speed_flat: speeds.flat,
    speed_up: speeds.up,
    speed_down: speeds.down,
    steps_hours: stepsHours,
    altitudes: result.altitudeProfile.minAndMax,
    global
  }

  fetch("/itineraries", {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(sent)
  });

}

const updateItinaryAndMeasurements = async (listOfPoints) => {


  const params = {
    resource: "bdtopo-osrm",
    profile: 'pedestrian',
    start: pointToIgnString(listOfPoints[0]),
    end: pointToIgnString(listOfPoints[listOfPoints.length - 1]),
    getSteps: false,
  }

  if (listOfPoints.length >= 3) {
    params["intermediates"] = listOfPoints.slice(1, listOfPoints.length - 1).map(pointToIgnString)
  }

  const response = await fetch('https://data.geopf.fr/navigation/itineraire', {
      redirect: "follow", method: "POST",
      body: JSON.stringify(params),
      headers: {'Accept': "application/json", 'Content-Type': 'application/json'},
    },
  )

  const body = await response.json()

  const newPathCoordinates = body.geometry.coordinates.map(handleLongLat)

  const portionsSeparators = body.portions.slice(1).map(({start}) => start)

  const {elevationsGlobal, elevationsPortions} = await getElevationsForCoords(body.geometry.coordinates, portionsSeparators, Math.ceil(body.distance / 120))

  const denivelesPerPortions = elevationsPortions.map((elevationsPortion) => getDeniveles(elevationsPortion))

  return {
    pathCoordinates: newPathCoordinates,
    distance: body.distance,
    altitudeProfile: {
      minAndMax: getMinimumAndMaximumsSimplified(elevationsGlobal),
      deniveles: denivelesPerPortions.reduce(
        (partialSum, element) => ({up: partialSum.up + element.up, down: partialSum.down + element.down}),
        {up: 0, down: 0}
      )
    },
    portions: body.portions.map(({distance, start}, index) => {
      return {
        distance,
        start,
        deniveles: denivelesPerPortions[index],
        minAndMax: getMinimumAndMaximumsSimplified(elevationsPortions[index])
      }
    }),
  }
}

export { reportResult }
export default updateItinaryAndMeasurements
